import { createAsyncThunk } from '@reduxjs/toolkit';
import { ExtraReducer, getSideEffectState } from '@utils/.';
import { BookingReducerProps } from '../type';
import { bookingApiService } from '@services/service-register';
import { RestaurantReservationParams } from '@core/models';

export const fetchReservations = createAsyncThunk(
  'booking/fetchRestaurantReservations',
  async (_, thunkApi) => {
    try {
      const reservations =
        await bookingApiService.getLocationReservations<RestaurantReservationParams>();
      return reservations;
    } catch (e: any) {
      return undefined;
    }
  }
);

const [fulfilled, pending, rejected] = getSideEffectState(fetchReservations);

export const fetchReservationsReducer = {
  [fulfilled]: (state, action) => {
    state.isLoading = false;
    state.reservations = action.payload || [];
  },
  [rejected]: (state, action) => {
    state.isLoading = false;
    state.reservations = [];
  },
  [pending]: (state, action) => {
    state.isLoading = true;
  },
} as ExtraReducer<BookingReducerProps>;
